import { Routes } from '@angular/router';
import { MasterPageComponent } from './core/components/master-page/master-page.component';

export const routes: Routes = [
  {
    path: '',
    component: MasterPageComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./main/ea/ea.routes').then(m => m.EA_ROUTES)
      },
      {path: 'tech-it', loadChildren: () => import('./main/techit/techit.routes').then(m => m.TECHIT_ROUTES)},
      {path: 'agency', loadChildren: () => import('./main/agency/agency.routes').then(m => m.AGENCY_ROUTES)},
      {path: 'cloud', loadChildren: () => import('./main/cloud/cloud.routes').then(m => m.CLOUD_ROUTES)},
      {path: 'training', loadChildren: () => import('./main/training/training.routes').then(m => m.TRAINING_ROUTES)},
      {path: 'resource', loadChildren: () => import('./main/resources/resource.routes').then(m => m.RESOURCE_ROUTES)},
      {path: 'contactez-nous', loadChildren: () => import('./main/shared/contact/contact-us/contact-us.routes').then(m => m.CONTACT_US_ROUTES)},
      {path: 'demande-devis', loadChildren: () => import('./main/shared/contact/request-for-quotation/request-for-quotation.routes').then(m => m.REQUEST_FOR_QUOTATION_ROUTES)},
      {path: 'boite-idees', loadChildren: () => import('./main/shared/contact/suggestion-box/suggestion-box.routes').then(m => m.SUGGESTION_BOX_ROUTES)}
    ]
  },
  {
    path: 'page-maintenance',
    loadComponent: () => import('./main/shared/page-maintenance/page-maintenance.component').then(m => m.PageMaintenanceComponent)
  }
];
